import React, { Component, Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import Slider from "react-slick";
import '../../polyfill/arrayFind';
// import {useMediaQuery} from "beautiful-react-hooks";
import { useMediaQuery } from 'react-responsive'

import MainHeader from "../layout/MainHeader";
import MainFooter from "../layout/MainFooter";
import QuestionDetails from "./SummaryQuestionDetails";
import SummaryArea from "./graph/SummaryArea";


const Summary = (props) => {
    document.body.className = 'survey survey--results';

    const isTablet = useMediaQuery({ query: '(max-width: 1023px)' });
    const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

    const settings = {
        dots: false,
        slide: null,
        infinite: false,
        arrows: false,
        centerMode: true,
        centerPadding: '30px',
        speed: 500,
        slidesToShow: 2,
        swipeToSlide: 1,
        slidesToScroll: 1,
        initialSlide: 1,
        variableWidth: true,
        outerEdgeLimit: true,
        responsive: [
            {
                breakpoint: 500,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0,
                }
            }
        ]
    };

    const [showDetails, setDetails] = useState(false);

    const computeAreas = () => {
        return Object.keys(props.survey).map((area, index) => (
            <SummaryArea area={area} key={index}
                         click={() => handleAreaClick(area)}
                         additionalClass={showDetails ? `area-${area} area--details` : ''} />
        ));
    };

    const getQuestionCode = (area) => {
        return props.survey[area].questions[0].code;
    };

    const handleBackClick = () => {
        setDetails(false);
        props.dispatch({ type: 'SHOW_SUMMARY_AREA', area: '', question: ''});
    };

    const handleAreaClick = (area) => {
        if (area === props.selectedArea) return;

        setDetails(true);
        props.dispatch({ type: 'SHOW_SUMMARY_AREA', area: area, question: getQuestionCode(area) });
    };

    const areas = computeAreas();

    return (
        <Fragment>
            <MainHeader>
                <h2>Twoje odpowiedzi</h2>

                {showDetails ?
                        !(isTablet && isPortrait) &&
                        <p>Aby poznać szczegóły, kliknij w okrąg lub kulkę.</p>
                    :
                        (isTablet && isPortrait) ?
                            <p>Wybrałeś jak większość w przypadku poniższej liczby pytań. Aby poznać szczegóły, wybierz obszar.</p>
                            :
                            <p>Wybrałeś jak większość w przypadku poniższej liczby pytań.</p>
                }
            </MainHeader>

            <div className={`areas ${showDetails && `areas--${props.selectedArea}`}`}>
                { isTablet ? (
                    !showDetails &&
                        <Slider {...settings}>
                            { areas }
                        </Slider>
                ) : areas  }

                {showDetails &&
                    <div className="results">
                        <div className="results__header">
                            <h4>
                                {props.survey[props.selectedArea].name}
                                {props.test[props.selectedArea].answers[props.selectedQuestion] &&
                                    <span className="results__disclaimer">
                                        Na to pytanie nie udzieliłeś odpowiedzi. Zobacz, jak odpowiadali inni.
                                    </span>
                                }
                            </h4>
                        </div>

                        {(isTablet && isPortrait) ?
                            props.survey[props.selectedArea].questions.map((question, index) => {
                                return (
                                    <QuestionDetails answer={props.test[props.selectedArea].answers[question.code]}
                                                     question={question}
                                                     key={index}
                                    />
                                )
                            })
                            :
                            <QuestionDetails
                                answer={props.test[props.selectedArea].answers[props.selectedQuestion]}
                                question={props.survey[props.selectedArea].questions.find((value) => {
                                    return value.code === props.selectedQuestion;
                                })}
                            />
                        }
                    </div>
                }
            </div>

            <MainFooter>
                <div className="info">
                    {showDetails ?
                        <button className="btn btn--secondary" onClick={handleBackClick}>Powrót</button>
                        :
                        <Link to="/survey" className="btn btn--secondary">Powrót</Link>
                    }
                </div>
                <div className="text" />
                <div className="actions">
                    {showDetails ?
                        <a href="/summary" className="btn btn--primary">Przejdź dalej</a>
                        :
                        !(isTablet && isPortrait) &&
                        <button className="btn btn--primary"
                                onClick={() => handleAreaClick('society')}>Przejdź dalej</button>
                    }
                </div>
            </MainFooter>
        </Fragment>
    );
};

const mapStateToProps = (state) => {
    return {
        test: state.test,
        survey: state.survey,
        selectedQuestion: state.globals.selectedSummaryQuestion,
        selectedArea: state.globals.selectedSummaryArea,
    }
};

export default connect(mapStateToProps)(Summary);



// WEBPACK FOOTER //
// ./sources/js/components/Summary/index.js